import script from "./TablePage.vue?vue&type=script&setup=true&lang=js"
export * from "./TablePage.vue?vue&type=script&setup=true&lang=js"

import "./TablePage.vue?vue&type=style&index=0&id=733dd645&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-733dd645"]])

export default __exports__